import { WifiPassword } from "@mui/icons-material";
// import AppleIcon from '@mui/icons-material/Apple';
import { Button, Grid, SvgIcon } from "@mui/material";
import React from "react";
import { isNativeWebView } from "../../utils/nativeAuthBridge";
import AppleInAppButton from "../AppleInAppButton";
import { useConfig } from "../auth";
import GoogleInAppButton from "../GoogleInAppButton";
import { redirectToProvider } from "../lib/allauth";
import { ReactComponent as Apple } from "../logos/apple.svg";
import { ReactComponent as Github } from "../logos/github-mark-white.svg";
import { ReactComponent as Google } from "../logos/google.svg";
import { ReactComponent as Linkedin } from "../logos/linkedin.svg";
import { ReactComponent as Spotify } from "../logos/spotify.svg";

interface ProviderListProps {
  callbackURL: string;
  process: any;
  accounts?: any;
}

const ProviderList: React.FC<ProviderListProps> = ({
  callbackURL,
  process,
  accounts,
}) => {
  const config = useConfig();
  const providers = config.data.socialaccount.providers;
  if (!providers.length) {
    return null;
  }

  function getIcon(provider: string) {
    if (provider === "apple") {
      return <SvgIcon component={Apple} inheritViewBox />;
    } else if (provider === "google") {
      return <SvgIcon component={Google} inheritViewBox />;
    } else if (provider === "spotify") {
      return <SvgIcon viewBox="0 0 496 512" component={Spotify} inheritViewBox />;
    } else if (provider === "github") {
      return <SvgIcon viewBox="0 0 98 96" component={Github} inheritViewBox />;
    } else if (provider === "linkedin") {
      return (
        <SvgIcon viewBox="0 0 72 72" component={Linkedin} inheritViewBox />
      );
    }
    return null;
  }

  return (
    <Grid container gap={2}>
      {providers.map((provider: any) => {
        const connected = accounts?.find(
          (a: any) => a.provider.id === provider.id
        );

        if (isNativeWebView() && provider.id === "google") {
          return (
            <GoogleInAppButton
              key={`${provider.id}-${provider.client_id || "default"}`}
              isConnected={!!connected}
              process={process}
            />
          );
        }

        if (isNativeWebView() && provider.id === "apple") {
          return (
            <AppleInAppButton
              key={`${provider.id}-${provider.client_id || "default"}`}
              isConnected={!!connected}
              process={process}
            />
          );
        }

        // @ts-ignore
        return (
          <Button
            startIcon={getIcon(provider.id)}
            endIcon={connected ? <WifiPassword /> : undefined}
            key={`${provider.id}-${provider.client_id || "default"}`}
            fullWidth
            variant={"outlined"}
            color={"inherit"}
            onClick={() =>
              redirectToProvider(provider.id, callbackURL, process)
            }
            data-attr="provider-list_provider"
            data-custom-id={provider.id}
          >
            Login with {" "} {provider.name}
          </Button>
        );
      })}
      {isNativeWebView() &&
        providers.some((provider: { id: string }) => provider.id === "google") &&
        !providers.some((provider: { id: string }) => provider.id === "apple") && (
          <AppleInAppButton
            key="apple-native-fallback"
            isConnected={false}
            process={process}
          />
        )}
    </Grid>
  );
};

export default ProviderList;
